import React from "react";

function Home(){
    return (
        <div style={{backgroundColor:'whitesmoke'}} className="container">
            <div className="text">
                <u>Books Library Portal</u>
                <h5>where you can add, update and delete books.</h5>
                <h6>Created using React.js</h6>
            </div>
       
        </div>
    );
}


export default Home;